export default __webpack_public_path__ + "static/media/strawberry.df436a16.png";